import React from "react";
import OnboardingWelcome from "../partners/onboarding/OnboardingWelcome";

export default function Onboarding() {
  
  return (
    <>
      <OnboardingWelcome />
    </>
  );
}